// Messages d'erreur de l'inscription (MOKA-360) : une consigne en français, jamais le texte
// technique renvoyé par Supabase.

export const ALREADY_REGISTERED_MESSAGE = 'Cette adresse email a déjà un compte Mokah+. Connectez-vous depuis l\'onglet Connexion, ou réinitialisez votre mot de passe si vous l\'avez oublié.';

/** Erreur d'inscription Supabase traduite en consigne, sans le message technique anglais. */
export function signUpErrorMessage(error: { message: string; status?: number; code?: string }): string {
  const message = error.message.toLowerCase();
  if (message.includes('already registered') || error.code === 'user_already_exists') {
    return ALREADY_REGISTERED_MESSAGE;
  }
  if (error.status === 429 || error.code === 'over_email_send_rate_limit' || message.includes('rate limit')) {
    return 'Trop de tentatives en peu de temps. Patientez une minute, puis réessayez.';
  }
  if (error.code === 'weak_password' || message.includes('password')) {
    return 'Ce mot de passe est refusé : il est trop courant ou trop simple. Choisissez-en un autre.';
  }
  if (error.code === 'email_address_invalid' || message.includes('email address')) {
    return 'Cette adresse email est refusée. Vérifiez-la, ou utilisez votre adresse professionnelle.';
  }
  return 'Votre compte n\'a pas pu être créé. Vérifiez votre connexion internet, puis réessayez.';
}
